import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getIsPresentationMode } from "../../ducks/layout/selectors";
import { togglePresentationMode as togglePresentationModeAction } from "../../ducks/layout/layout";
import { getLocationType } from "../../ducks/location/selectors";
import { RouteName } from "../../appConfig/types";

export const usePresentationMode = () => {
  const dispatch = useDispatch();
  const isPresentationMode = useSelector(getIsPresentationMode);
  const locationType = useSelector(getLocationType);

  const togglePresentationMode = useCallback(() => {
    dispatch(togglePresentationModeAction());
  }, [dispatch]);

  const isProjectConfig = locationType === RouteName.ProjectConfiguration;

  return {
    isPresentationMode: isPresentationMode || isProjectConfig,
    isProjectConfig,
    togglePresentationMode,
  };
};
